<template>
  <el-breadcrumb separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span
          class="no-redirect"
          v-if="
            index === levelList.length - 1 || item.redirect === 'noRedirect'
          "
          >{{ item.meta.title }}</span
        >
        <a v-else @click.prevent="$router.push(item.path)">{{
          item.meta.title
        }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>
<script>
export default {
  data() {
    return {
      levelList: null,
    };
  },
  created() {
    this.getBreadCrumb();
  },
  watch: {
    $route(route) {
      this.getBreadCrumb();
    },
  },
  methods: {
    getBreadCrumb() {
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      const first = matched[0];
      if (!this.isHome(first)) {
        matched = [{ path: "/dashborad", meta: { title: "首页" } }].concat(
          matched
        );
      }
      this.levelList = matched;
    },
    isHome(route) {
      const name = route && route.name;
      if (!name) return false;

      return name === "Dashborad";
    },
  },
};
</script>
<style lang="less" scoped>
.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-move {
  transition: all 0.5s;
}

.breadcrumb-leave-active {
  position: absolute;
}

.el-breadcrumb {
  float: left;
  height: 50px;
  line-height: 50px;
  margin-left: 8px;
  font-size: 14px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>